import * as r from "react";
import l from "./chunk901.js";
import w from "./chunk948.js";
import C from "./chunk992.js";
import L from "./chunk946.js";
import h from "./chunk934.js";
import b from "./chunk993.js";
import g from "./chunk994.js";
function T(c) {
  return c.substring(2).toLowerCase();
}
function D(c, s) {
  return s.documentElement.clientWidth < c.clientX || s.documentElement.clientHeight < c.clientY;
}
function R(c) {
  const {
    children: s,
    disableReactTree: y = !1,
    mouseEvent: i = "onClick",
    onClickAway: k,
    touchEvent: u = "onTouchEnd"
  } = c, a = r.useRef(!1), o = r.useRef(null), d = r.useRef(!1), m = r.useRef(!1);
  r.useEffect(() => (setTimeout(() => {
    d.current = !0;
  }, 0), () => {
    d.current = !1;
  }), []);
  const P = w(C(s), o), f = L((e) => {
    const n = m.current;
    m.current = !1;
    const t = h(o.current);
    if (!d.current || !o.current || "clientX" in e && D(e, t))
      return;
    if (a.current) {
      a.current = !1;
      return;
    }
    let E;
    e.composedPath ? E = e.composedPath().includes(o.current) : E = !t.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      e.target
    ) || o.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      e.target
    ), !E && (y || !n) && k(e);
  }), v = (e) => (n) => {
    m.current = !0;
    const t = s.props[e];
    t && t(n);
  }, p = {
    ref: P
  };
  return u !== !1 && (p[u] = v(u)), r.useEffect(() => {
    if (u !== !1) {
      const e = T(u), n = h(o.current), t = () => {
        a.current = !0;
      };
      return n.addEventListener(e, f), n.addEventListener("touchmove", t), () => {
        n.removeEventListener(e, f), n.removeEventListener("touchmove", t);
      };
    }
  }, [f, u]), i !== !1 && (p[i] = v(i)), r.useEffect(() => {
    if (i !== !1) {
      const e = T(i), n = h(o.current);
      return n.addEventListener(e, f), () => {
        n.removeEventListener(e, f);
      };
    }
  }, [f, i]), /* @__PURE__ */ r.cloneElement(s, p);
}
process.env.NODE_ENV !== "production" && (R.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: b.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: l.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: l.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: l.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: l.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (R.propTypes = g(R.propTypes));
export {
  R as ClickAwayListener
};
